import type {ReactNode} from 'react'
import css from './FormLabel.module.css'
import {TextNorm} from "../../../Text";

interface FormLabelProps {
    children: ReactNode
}

const FormLabel = ({children}: FormLabelProps) => {
    return (
        <TextNorm className={css.form_label}>{children}</TextNorm>
    )
}

export default FormLabel
